export default {"src":"/_next/static/image/public/images/pay_at_counter.bef87ab1e96bb55a97e29f32541e1f81.svg","height":133,"width":220};